import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import ClinicPayoutReports from './ClinicPayoutReports'

export default function SingularClinicPayoutReports() {
  const { brandSlug } = useParams()
  const [clinicBrand, setClinicBrand] = useState()
  async function getClinicBrand() {
    const resp = await getSPDataWithParams(`/api/secure/cc/support/clinic-brand/get`, {
      slug: brandSlug,
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const brand = getDataMapFromCommonResponse(resp)?.['clinic-brand']
        setClinicBrand(brand)
      }
    }
  }

  useEffect(() => {
    getClinicBrand()
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      {!clinicBrand ? (
        <LoadingSpinner />
      ) : (
        <ClinicPayoutReports clinicBrandData={clinicBrand} hideClinicBrandDropDown />
      )}
    </div>
  )
}
